import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
    selector: 'gallery-cell',
    templateUrl: 'gallery-cell.template.html' ,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GalleryCell {
    @Input() item: any;
    @Input() cta: string = "VIEW";
    constructor(
    ) { }

    ngOnInit() {
    }

}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/gallery/gallery-cell/gallery-cell.component.ts